import Skeleton from '@material-ui/lab/Skeleton/Skeleton'

import useStyles from './styles/AuditLogsFormListRow.styles'

interface AuditLogsFormListRowSkeletonProps {
  isRoleAdmin: boolean
}
const AuditLogsFormListRowSkeleton: React.FC<
  AuditLogsFormListRowSkeletonProps
> = ({ isRoleAdmin }) => {
  const classes = useStyles()

  return (
    <div className={[classes.root, isRoleAdmin && classes.adminRoot].join(' ')}>
      {Array(isRoleAdmin ? 8 : 7)
        .fill(' ')
        .map((_, index) => (
          <div key={index}>
            <Skeleton animation="wave" className={classes.skeleton} />
          </div>
        ))}
    </div>
  )
}
export default AuditLogsFormListRowSkeleton
